var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from '../core/model';
import { Group, Polygon } from '../element';
function getRectPosition(rect, h, v) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    var px = h === 'left' ? x : x + width;
    var py = v === 'top' ? y : y + height;
    return { x: px, y: py };
}
var PointHighlight = /** @class */ (function (_super) {
    __extends(PointHighlight, _super);
    function PointHighlight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'point-link';
        _this._group = new Group();
        return _this;
    }
    PointHighlight.prototype.getEvents = function () {
        return {
            'point:mouseover': this.onPointMouseOver,
            'point:mouseout': this.onPointMouseOut,
        };
    };
    PointHighlight.prototype.onPointMouseOver = function (event) {
        var _a = event.point, seriesColor = _a.seriesColor, seriesIndex = _a.seriesIndex;
        var seriesModel = this.chart.getSeriesModel(seriesIndex);
        var coord = seriesModel.getCoord();
        var categoryAxis = coord.getCategoryAxis();
        var reversed = categoryAxis.shortType !== 'x';
        var points = seriesModel.getState().points;
        var inverse = categoryAxis.getOption().inverse;
        var startSide = reversed ? (inverse ? 'bottom' : 'top') : inverse ? 'left' : 'right';
        var endSide = reversed ? (inverse ? 'top' : 'bottom') : inverse ? 'right' : 'left';
        var otherSide = reversed
            ? ['left', 'right', 'right', 'left']
            : ['bottom', 'top', 'top', 'bottom'];
        var _loop_1 = function (i) {
            var current = points[i];
            var next = points[i + 1];
            var shape = current.shape;
            var nexShape = next.shape;
            if (current.visible && next.visible) {
                this_1._group.add(new Polygon({
                    pointList: otherSide.map(function (side, index) {
                        var useShape = index < 2 ? shape : nexShape;
                        var h = reversed ? side : index < 2 ? startSide : endSide;
                        var v = reversed ? (index < 2 ? startSide : endSide) : side;
                        return getRectPosition(useShape, h, v);
                    }),
                    fill: seriesColor,
                    opacity: 0.4,
                    pointerEvents: 'none',
                }));
            }
        };
        var this_1 = this;
        for (var i = 0; i < points.length - 1; i++) {
            _loop_1(i);
        }
        this.chart.getRenderInstance().add(this._group);
    };
    PointHighlight.prototype.onPointMouseOut = function () {
        this.chart.getRenderInstance().remove(this._group);
    };
    return PointHighlight;
}(Model));
export default PointHighlight;
